import Search from '@ixigo/icons/Search';
import Button from '@ixigo/iui/Button';
import { DisplayField } from '@repo/shared/components';

export interface SearchBarProps {
	searchValue?: string;
	onSearchClick?: () => void;
}

export function SearchBar({ searchValue, onSearchClick }: SearchBarProps) {
	const handleSearch = () => {
		onSearchClick?.();
	};

	const handleSearchFieldClick = () => {
		onSearchClick?.();
	};

	return (
		<div className="flex w-full overflow-hidden rounded-30">
			<DisplayField
				icon={<Search />}
				value={searchValue}
				placeholder="Where are you going?"
				onClick={handleSearchFieldClick}
				className="flex-1 bg-tertiary truncate"
			/>
			<Button
				variant="solid"
				color="brand"
				className="px-6 py-3 rounded-none shadow-sm"
				onClick={handleSearch}
			>
				Search
			</Button>
		</div>
	);
}
